import { shallowMount, createLocalVue } from "@vue/test-utils";
import Vuex from "vuex";
import App from "@/App.vue";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("App.vue", () => {
  let store;

  beforeEach(() => {
    store = new Vuex.Store({
      state: {
        isLoading: false,
        isAuthenticated: false
      }
    });
  });

  it("renders the component", () => {
    const wrapper = shallowMount(App, { store, localVue });
    expect(wrapper.exists()).toBe(true);
  });
});
